// Credenciales landing assets (CDN folder uploaded by the client). Raster
// exports are 2x: render them at half their pixel size.
export const CREDENCIALES_ASSETS = `${AZURE_BASE_URL}/credenciales`

export type CredencialesImageFolder = 'DESKTOP' | 'MOBILE'

export const credencialesImage = (folder: CredencialesImageFolder, name: string) =>
  encodeURI(`${CREDENCIALES_ASSETS}/${folder}/${name}.webp`)

export const credencialesVideo = (name: string) => encodeURI(`${CREDENCIALES_ASSETS}/VIDEO/${name}`)

export const CREDENCIALES_VIDEOS = {
  heroMobile: 'header_credenciales_mobile.mp4',
  heroDesktop: 'header_credenciales_desktop.mp4'
}

// Anchors used by the in-page scroll CTAs
export const CREDENCIALES_INTRO_ID = 'que-es'
export const CREDENCIALES_STORES_ID = 'donde-la-consigo'

export interface CredencialesStore {
  key: string
  name: string
  url: string
}

// Points of sale (Phase 4): only the stores with a live link
export const STORES: CredencialesStore[] = [
  { key: 'amazon', name: 'Amazon', url: 'https://a.co/d/06SQaN5a' },
  { key: 'ml', name: 'Mercado Libre', url: 'https://www.mercadolibre.com.mx/tienda/heineken/heineken' },
  {
    key: 'walmart',
    name: 'Walmart',
    url: 'https://www.walmart.com.mx/ip/cerveza-clara-heineken-6-botellas-de-355-ml-c-u/00750104999927'
  }
]
